;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React, { useState, useEffect, useCallback } from "react"
import useEmblaCarousel from "embla-carousel-react"
import styles from "./styles.module.scss"
import map from "lodash/map"
import Autoplay from "embla-carousel-autoplay"

const EmblaCarouselQuotes = ({
  quotes,
  page,
  handleChangePage,
  // setInactiveGrayScale,
}) => {
  // Lazy state gives the plugin a stable identity that's safe to read in render
  const [autoplay] = useState(() =>
    Autoplay({
      delay: 4500,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
      rootNode: (emblaRoot) => emblaRoot.parentElement,
    }),
  )

  const [viewportRef, embla] = useEmblaCarousel(
    {
      skipSnaps: false,
      loop: true,
      slidesToScroll: 1,
    },
    [autoplay],
  )

  const onSelect = useCallback(() => {
    if (!embla) return
    const currentSnappedPage = embla.selectedScrollSnap()
    if (currentSnappedPage !== page) {
      handleChangePage(embla.selectedScrollSnap())
      autoplay.reset()
    }
  }, [embla, page, handleChangePage, autoplay]) // Now includes handleChangePage

  useEffect(() => {
    if (!embla) return

    onSelect()
    embla.on("select", onSelect)

    embla.scrollTo(page)
  }, [embla, page, onSelect])

  const renderQuoteNameDivArray = ({ quote, name, index }) => {
    return [
      <div className={styles["quote"]} key={`quote-${index}`}>
        {quote}
      </div>,
      <div className={styles["person-name"]} key={`name-${index}`}>
        - {name}
      </div>,
    ]
  }

  return (
    // <div className={styles["embla-container"]}>
    // </div>
    <div className={styles["embla"]}>
      <div className={styles["embla__viewport"]} ref={viewportRef}>
        <div className={styles["embla__container"]}>
          {map(quotes, ({ quote, name }, index) => (
            <div className={styles["embla__slide"]} key={index}>
              <div
                className={`${styles["embla__slide__inner"]}`}
                // onMouseEnter={() => setInactiveGrayScale(true)}
                // onMouseLeave={() => setInactiveGrayScale(false)}
              >
                {renderQuoteNameDivArray({
                  quote,
                  name,
                  index,
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default EmblaCarouselQuotes
